import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconTextFormatBold16(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={16}
            height={16}
            className={customClassName}
            name="IconTextFormatBold16"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                d="M11.659 5.257C11.659 3.234 10.326 2 7.876 2H4v12h3.938C10.651 14 12 12.783 12 10.486c0-1.303-.713-2.469-2.264-2.64 1.256-.206 1.923-1.337 1.923-2.589m-5.21-.806h1.194c1.101 0 1.489.532 1.489 1.166 0 .703-.388 1.166-1.225 1.166H6.45zm3.04 5.846c0 .823-.559 1.269-1.582 1.269H6.45v-2.52h1.44c1.101 0 1.597.394 1.597 1.251"
            />
        </svg>
    );
}
export default memo(IconTextFormatBold16);
